import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";

export interface DialogData_ExportAssessmentDialogInput extends MatDialogDataBaseInput {
	assessmentIds: string[];
}

export interface DialogData_ExportAssessmentDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-export-assessments-dialog",
	templateUrl: "./export-assessments-dialog.component.html",
	styleUrls: ["./export-assessments-dialog.component.scss"],
	standalone: false,
})
export class ExportAssessmentsDialogComponent extends BasicMaterialDialog<
	ExportAssessmentsDialogComponent,
	DialogData_ExportAssessmentDialogInput,
	DialogData_ExportAssessmentDialogOutput
> {
	T = Translations;

	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit(): void {}
}
